import o from "./index49.js";
import { getGlobal as e } from "./index21.js";
var g = function() {
  for (var t = [], r = 0; r < arguments.length; r++)
    t[r] = arguments[r];
  var a = e();
  return (a && a.fetch || o).apply(void 0, t);
};
export {
  g as fetch
};
//# sourceMappingURL=index32.js.map
